// The PostHog identity of the signed-in person.
//
// distinct_id is the PERSON record id, namespaced as `person-<id>`: one
// PostHog person per human across every sign-in, the same key Crucible sends.
// The namespace keeps it apart from the old users.id distinct ids, which are
// small integers too and would otherwise name a different person.
//
// Which sign-in an event came from is context, not identity: the organization
// is a PostHog group, and member_id and org_id ride on every event.
//
// Old users.id distinct ids were merged into their person once, server side,
// after the users table was dropped; nothing here sends them any more.

export interface PostHogLike {
  identify(distinctId?: string, properties?: Record<string, unknown>): void
  group(groupType: string, groupKey: string, properties?: Record<string, unknown>): void
  register(properties: Record<string, unknown>): void
  capture(event: string, properties?: Record<string, unknown>): void
}

export interface SignedInIdentity {
  personId: number | null
  memberId: string | null
  orgId: string | null
  email?: string | null
  name?: string | null
}

export const personDistinctId = (personId: number): string => `person-${personId}`

/** Identify the signed-in person to PostHog. With no person id (a session
 *  minted before the claim existed) it leaves the browser anonymous. */
export function identifySignedIn(posthog: PostHogLike, who: SignedInIdentity): void {
  if (who.personId == null) return
  const traits = { email: who.email ?? undefined, username: who.name ?? undefined }
  posthog.identify(personDistinctId(who.personId), traits)
  if (who.orgId) posthog.group("organization", who.orgId)
  posthog.register({ member_id: who.memberId ?? undefined, org_id: who.orgId ?? undefined })
}
